import { useProcess } from '@fasstech/oip-starter-utils/app';
import { adjust, always, compose, dissoc, evolve, propOr } from 'ramda';
import { isNilOrEmpty } from '@@serverHelpers/index.mjs';

const FormatExtraCommission = (offer) => {
  const { context } = useProcess();
  const brokerId = propOr('', 'brokerId', context);

  const overrideCommission = evolve({
    packs: adjust(
      0,
      evolve({
        commission: (commission) =>
          compose(
            dissoc('rates'),
            evolve({
              rate: always('00'),
              defaultRate: always('00')
            })
          )(commission)
      })
    )
  });

  return isNilOrEmpty(brokerId) ? overrideCommission(offer) : offer;
};

export default FormatExtraCommission;
